import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { AppRoutes } from "@/routes/AppRoutes"
import { Toaster } from "@/components/ui/toaster"
import { SidebarProvider } from "@/contexts/SidebarContext"
import "./App.css"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SidebarProvider>
        <div className="min-h-screen flex w-full bg-gradient-to-br from-background to-background/95">
          <AppRoutes />
          <Toaster />
        </div>
      </SidebarProvider>
    </QueryClientProvider>
  )
}

export default App